module.exports = __webpack_public_path__ + "media/images/front/icons_mypage-3b781a7594acc9c12a5dd8169cb32775.png";